import { render, staticRenderFns } from "./SalesEdit_Items.vue?vue&type=template&id=9a9bb6bc&"
import script from "./SalesEdit_Items.vue?vue&type=script&lang=js&"
export * from "./SalesEdit_Items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports